var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_6896)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.69842 3.69843C3.99131 3.40554 4.46618 3.40554 4.75908 3.69843L12.3015 11.2409C12.5944 11.5338 12.5944 12.0087 12.3015 12.3016C12.0087 12.5945 11.5338 12.5945 11.2409 12.3016L7.99998 9.06066L4.75908 12.3016C4.46618 12.5945 3.99131 12.5945 3.69842 12.3016C3.40552 12.0087 3.40552 11.5338 3.69842 11.2409L6.93932 8L3.69842 4.75909C3.40552 4.4662 3.40552 3.99133 3.69842 3.69843ZM8.8839 7.11609C8.591 6.82319 8.591 6.34832 8.8839 6.05543L11.2409 3.69843C11.5338 3.40554 12.0087 3.40554 12.3015 3.69843C12.5944 3.99133 12.5944 4.4662 12.3015 4.75909L9.94456 7.11609C9.65166 7.40898 9.17679 7.40898 8.8839 7.11609Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_6896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b7b9409e.svg";
export { ForwardRef as ReactComponent };